import { render, staticRenderFns } from "./LocalizationManager.vue?vue&type=template&id=ba229aaa"
import script from "./LocalizationManager.vue?vue&type=script&lang=js"
export * from "./LocalizationManager.vue?vue&type=script&lang=js"
import style0 from "./LocalizationManager.vue?vue&type=style&index=0&id=ba229aaa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports